export default "__VITE_ASSET__DulAqVjy__"